import { getUserIdentity } from "../lib/identity";

const EMAIL_SHAPED = /^[^@\s]+@[^@\s]+$/;
const EXPLICIT_NON_EMAIL_TYPES = new Set(["qsUsername", "discordUsername"]);

export function UserIdentity({ user, showIdentifier = true, className = "" }) {
  if (!user) return null;
  const { displayName, publicIdentifier, isDuplicate } = getUserIdentity(user);

  if (!displayName || isDuplicate) {
    // Defense-in-depth: only for an EXPLICIT non-email type (qsUsername/
    // discordUsername) do we withhold and render a neutral placeholder when
    // there is no usable handle (publicIdentifier is empty or degenerated to an
    // email-shaped value). An absent/null type means DEFAULT EMAIL, so an
    // untyped object (e.g. an unregistered invite-by-email chip) renders its
    // email — never blanked.
    if (
      !displayName &&
      EXPLICIT_NON_EMAIL_TYPES.has(user.publicIdentifierType) &&
      (!publicIdentifier ||
        EMAIL_SHAPED.test(String(publicIdentifier || "").trim()))
    ) {
      return <span className={className}>Someone</span>;
    }
    return <span className={className}>{publicIdentifier}</span>;
  }

  if (!showIdentifier || !publicIdentifier) {
    return <span className={className}>{displayName}</span>;
  }

  return (
    <span className={className}>
      {displayName} <span className="text-slate-500 dark:text-slate-400">({publicIdentifier})</span>
    </span>
  );
}
